import React from 'react';
import { connectWithScope } from '#packages/apilib';
import { hoc } from '#packages/util';

import { DEPRECATED_COMPONENTS_DATA, PANEL_NAME } from '../constants';
import { DeprecationOverlayScope } from '../scope';
import DeprecationOverlayItem from './deprecationOverlayItem';
import {
  shouldShowDeprecationOverlaySel,
  layoutPropsSel,
  getStateMapperArgsFromEditorAPI,
} from '../selectors/selectors';

import type { CompRef } from 'types/documentServices';

interface LayoutStateProps {
  isDragging: boolean;
  selectedComp: CompRef[];
}

type DeprecationOverlayContainerProps = LayoutStateProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

const DeprecationOverlayContainer: React.FC<
  DeprecationOverlayContainerProps
> = ({
  deprecatedComponentsOnStage,
  selectedComp,
  isDragging,
  openDeprecationModal,
}) => {
  return (
    <>
      {deprecatedComponentsOnStage.map((comp) => {
        const { compRef, compType, compLayout } = comp;
        return (
          <DeprecationOverlayItem
            key={`deprecationOverlay-${compRef.id}`}
            compRef={compRef}
            compType={compType}
            compLayout={compLayout}
            isDragging={isDragging}
            selectedComp={selectedComp}
            openDeprecationModal={openDeprecationModal}
          />
        );
      })}
    </>
  );
};

const mapStateToProps = (scope: DeprecationOverlayScope) => {
  const deprecatedComponentsOnStage: {
    compRef: CompRef;
    compType: string;
    compLayout: React.CSSProperties;
  }[] = [];
  const mapperArgs = getStateMapperArgsFromEditorAPI(scope.editorAPI);

  Object.keys(DEPRECATED_COMPONENTS_DATA).forEach((deprecatedCompType) => {
    const compList = scope.components.get.byType(
      deprecatedCompType,
      scope.pages.getCurrentPage(),
    );

    compList.forEach((compRef) => {
      const rect = scope.components.layout.getRelativeToScreen_rect(compRef);
      const compLayout = {
        position: 'absolute',
        width: rect.width,
        height: rect.height,
        top: rect.y,
        left: rect.x,
      } as React.CSSProperties;

      deprecatedComponentsOnStage.push({
        compRef,
        compType: deprecatedCompType,
        compLayout,
      });
    });
  });

  return {
    deprecatedComponentsOnStage,
    ...layoutPropsSel(mapperArgs),
  };
};

const mapDispatchToProps = (scope: DeprecationOverlayScope) => {
  const editorAPI = scope.editorAPI;

  return {
    openDeprecationModal: (compType: string) => {
      editorAPI.panelManager.openPanel(PANEL_NAME, {
        compType,
        origin: 'banner_click',
      });
    },
  };
};

export const ConnectedDeprecationOverlayContainer = connectWithScope(
  () => DeprecationOverlayScope,
  DeprecationOverlayContainer,
  mapStateToProps,
  mapDispatchToProps,
);

export default hoc.withConditionalRender(
  hoc.STORES.EDITOR_API,
  shouldShowDeprecationOverlaySel,
)(ConnectedDeprecationOverlayContainer);
